import styled from "styled-components";
import { Box } from "theme-ui";
import { themevals as theme } from "theme/themevals";

interface CustomProps {
  $submitting?: boolean;
  $errors?: any;
  rows?: number;
  $customStyles?: any;
  prefix?:any;
  suffix?:any;
  readonly?:boolean;
}

export const inputStyles = {  
  borderRadius: 6,  
  paddingLeft: 10,
  paddingRight: 10,
  minHeight:36,
};

export const Prefix = styled.div`
  position:absolute;
  left:0px;
  top:50%;
  transform:translateY(-50%);
  font-size:12px;
  font-weight:500;
  font-family:"Poppins";
  color:#818181;
  background-color:#EBEBEB;
  height:100%;
  display:flex;
  align-items:center;
  padding-left:5px;
  padding-right:5px;
  border:1px solid #D6D6D6;
  border-bottom-left-radius:6px;
  border-top-left-radius:6px;
  overflow:hidden;
  z-index:1;
`

export const Suffix = styled.div`
  position:absolute;
  right:0px;
  top:50%;
  transform:translateY(-50%);
  font-size:12px;
  font-weight:500;
  font-family:"Poppins";
  color:#818181;
  background-color:#EBEBEB;
  height:100%;
  display:flex;
  align-items:center;
  padding-left:5px;
  padding-right:5px;
  border:1px solid #D6D6D6;
  border-bottom-right-radius:6px;
  border-top-right-radius:6px;
  overflow:hidden;
  z-index:1;
`

export const InputWrap = styled(Box)<CustomProps>`
  && {margin-bottom: ${(props) => typeof props.$customStyles?.marginBottom !== "undefined" ? props.$customStyles.marginBottom : "30px"};}

  display: flex;
  flex-direction: column;
  position:relative;  
  width:100%;
  &:focus-within ${Suffix} {
    border-top: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
  }
    &:focus-within ${Prefix} {
    border-top: 1px solid black;
    border-left: 1px solid black;
    border-bottom: 1px solid black;
  }
  input{
    height: 36px;
    max-width: 100%;
    font-family: "Poppins";
    font-size: 14px;
    font-weight: 500;
    border: 1px solid ${(props) => props.$errors ? theme.colors.danger + "!important" : theme.colors.mdgrey};
    color: ${(props) => props.readonly ? theme.colors.dkgrey : theme.colors.black};
    ${inputStyles}
    padding-left:${(props) => props.prefix ? "25px" : "10px"};
    position:relative;
    z-index:1;
    padding-right: ${(props) => (props.suffix ? `${18 + props.suffix.length * 5}px` : "10px")};
    background-color: ${theme.colors.white};
  }
  textarea {    
    font-family: "Poppins";
    font-size: 14px;
    font-weight: 500;
    max-width: 100%;
    border: 1px solid ${(props) => props.$errors ? theme.colors.danger + "!important" : theme.colors.mdgrey};
    color: ${theme.colors.black};
    border-radius: 6px;
    height: ${(props) => props.rows == 1 ? "36px" : "auto"};
  }
  select{
    height: 44px;
    max-width: 100%;
    border: 1px solid ${(props) => props.$errors ? theme.colors.danger + "!important" : theme.colors.base_300};
    color: ${theme.colors.body};
  }
`;



export const labelStyles = {
  marginBottom: 0,
  display: "flex",
  justifyContent : "space-between",
  alignItems: "flex-end",
  fontSize: 12,
  fontWeight: 500,
  fontFamily:"Poppins"
};

export const LabelWrapper =  styled.div`
  margin-bottom: 8px;
  display: flex;
  width: 100%;
  label {
    color: ${theme.colors.dkgrey};
    ${labelStyles}
  }
  small {
    font-style: italic; font-size: .75rem; color: ${theme.colors.ltgrey};
  }
`;



export const Error = styled.div` 
  color:${theme.colors.danger};
  margin-top:10px; 
  font-size:12px;
  font-weight: 600;
  font-family:"Poppins";
  position:absolute;
  bottom:-25px;
`


export const InnerInputWrap = styled.div`
  position:relative;
  width:100%;
  `